import { notification } from 'antd';

type WhyAntdDoesNotExposeThisType = Parameters<typeof notification.open>[0];

type AllowedProps = Pick<
  WhyAntdDoesNotExposeThisType,
  'message' | 'description' | 'icon' | 'duration' | 'key' | 'placement'
>;

// FIXME: we should put this into a works general context and expose
//  it as a hook

// Proxy to whatever lib we might use for toast/notification/alert
export const showNotification = (props: AllowedProps) =>
  notification.open(props);
